export default (() => {
  // Call this to smooth scroll to a DOM element
  function smoothScrollTo(element) {
    const supportsNativeSmoothScroll = 'scrollBehavior' in document.documentElement.style
    let y = Math.round(element.getBoundingClientRect().top + window.pageYOffset)

    y -= 70 // Add some offset

    if (!supportsNativeSmoothScroll) {
      window.scrollTo(0, y)
    } else {
      window.scrollTo({ top: y, behavior: 'smooth' })
    }
  }

  function scrollToHeading(text) {
    var regex = new RegExp('^' + text.toLowerCase(), 'i')

    // Find all headings that contain the string, and scroll to first one found
    const headings = $('h2,h3,h4,h5').get()
    for (var i = 0; i < headings.length; i++) {
      const h = headings[i]
      const text = h.innerText.toLowerCase()

      if (regex.exec(text)) {
        smoothScrollTo(h)
        break
      }
    }
  }

  function getAnchorFromUrl(url = null) {
    if (!url) url = window.location.href

    const anchors = url.split('#')
    const result = /#([^?]+)/i.exec(url)
    if (result && result[1]) {
      return decodeURIComponent(result[1])
    }

    return null
  }

  // Look for links with #<something> in their href,
  // scroll to when clicked and allow the address bar to update with #
  $('a[href*="#"]').each((_, item) => {
    const el = $(item)
    const href = el.attr('href')
    const anchor = getAnchorFromUrl(href)
    if (anchor) {
      el.on('click', (e) => {
        // If mobile menu is open, we need to close it and then scroll
        let waitASec = false
        if (window.closeMobileMenu) waitASec = window.closeMobileMenu()

        if (waitASec) setTimeout(() => scrollToHeading(anchor), 400)
        else scrollToHeading(anchor)
      })
    }
  })

  // On page load, check for # in the address bar, and smooth scroll there
  $(function () {
    const anchor = getAnchorFromUrl()
    if (anchor) scrollToHeading(anchor)
  })
})()
